module.exports = __webpack_public_path__ + "static/media/comicall.ad498db3.png";